import React from 'react';
import { GatsbyImage } from "gatsby-plugin-image"
import dateIcon from '../images/icons/calendar-white.png';
import timeIcon from '../images/icons/clock-white.png';
import Button from './Button';
import comingSoonImage from '../images/video-coming-soon.png';

const SingleWebinarHeroSection = ({ title, bgImageData, webinarDateObject, getOrdinalSuffix, ytLink }) => {
    const day = webinarDateObject.getDate();
    const month = webinarDateObject.toLocaleString('en-GB', { month: 'long' });
    const year = webinarDateObject.getFullYear();
    const formattedDate = `${day}${getOrdinalSuffix(webinarDateObject)} ${month} ${year}`;
    const formattedTime = webinarDateObject.toLocaleTimeString();
    const youtubeUrl = ytLink;

    // Determine if the webinar is upcoming
    const isUpcoming = webinarDateObject > new Date();

    return (
        <div className="grid grid-cols-12 w-full h-full relative m-0 p-0 px-8 lg:px-0">
            <GatsbyImage
                className="absolute w-full h-full"
                style={{ position: "absolute", zIndex: -1 }}
                image={bgImageData}
                alt="{title} Background Image"
            />
            <div className="absolute w-full h-full bg-holborn-blue opacity-80" style={{ zIndex: 0 }}></div>
            <div className="col-span-full lg:col-start-2 lg:col-end-6 py-20 lg:py-36" style={{zIndex: 2}}>
                <span className={` px-8 py-3 mb-6 ${isUpcoming ? 'bg-holborn-red text-white' : 'bg-holborn-light-blue text-holborn-blue'}`}>
                    {isUpcoming ? 'Live Event' : 'On Demand'}
                </span>
                <h1 className="text-4xl text-white font-bold mb-2 mt-10">{title}</h1>
                <div className='flex flex-row items-center justify-start gap-10 pt-4 pb-6'>
                    <p className="text-white">
                        <img src={dateIcon} alt="Calendar Icon" className="inline-block mr-2" style={{ width: '25px', height: '25px', marginTop:'-5px' }} />
                        {formattedDate}
                    </p>
                    <p className="text-white">
                        <img src={timeIcon} alt="Clock Icon" className="inline-block mr-2" style={{ width: '25px', height: '25px', marginTop:'-3px' }} />
                        {formattedTime}
                    </p>
                </div>
                <Button 
                    style={{marginTop:'2rem'}} 
                    onClick={() => {
                        if (!isUpcoming) {
                            document.getElementById('webinar-video').scrollIntoView({ behavior: 'smooth' });
                        }
                    }}
                    href={isUpcoming ? '#form' : '#webinar-video'} 
                    color='holborn-greenWhite'
                >
                    {isUpcoming ? 'Register your spot' : 'Watch the Webinar'}
                </Button>
            </div>
           {!isUpcoming && (
            <div id="webinar-video" className="col-span-full lg:col-start-8 lg:col-end-12 py-0 lg:py-36" style={{zIndex: 2}}>
                <div className='video-wrapper pb-20 lg:pb-0'>
                {youtubeUrl ? (
                    <iframe
                    className="responsive-iframe"
                    src={youtubeUrl}
                    title={title}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen={true}
                    ></iframe>
                ) : (
                    <img src={comingSoonImage} alt="Coming Soon" />
                )}
            </div>
        </div>
        )}
        </div>
    );
};

export default SingleWebinarHeroSection;